const filters = {
  uppercase: value => value instanceof String ? value.toUpperCase() : value
}
export default filters
